export const vatValidatorRegExp = /^[A-Z]+[A-Z\s\d]+$/;

const validateVAT = (string: string): boolean => vatValidatorRegExp.test(string);

export default validateVAT;
